import React, {useRef, useState, Fragment, useEffect} from 'react';
import PropTypes from 'prop-types';
import styles from './NewFeatureIndicator.scss';
import InfoPopup from '../InfoPopup/InfoPopup';
import {trackNewFeatureDotEvent} from '../../lib/tracking';
import {getLocalStorageItem, setLocalStorageItem} from '../../lib/localStorage';

/**
 * Usage: Wrap this with a <div> position absolute on the parent component to add more flexibility on the dot placement
 * */
const NewFeatureIndicator = (props) => {
  const {title, content, property, id} = props;
  const dotIndicatorRef = useRef();
  const featureId = 'feature.' + id;
  const newVisit = !getLocalStorageItem(featureId);
  const shouldAutoOpen = featureId && newVisit;
  const [openInfoModal, setOpenInfoModal] = useState(shouldAutoOpen);

  useEffect(() => {
    if (property) {
      trackNewFeatureDotEvent(property, 'new_feature_impression');
    }
    if (shouldAutoOpen) {
      setOpenInfoModal(true);
      setLocalStorageItem(featureId, true);
    }
  }, []);

  return <Fragment>
    <div
      className={styles.dotOthShade}
      ref={dotIndicatorRef}
      onClick={() => {
        setOpenInfoModal(true);
        trackNewFeatureDotEvent(property, 'new_feature_interaction');
      }}
      title={title}
    />
    <InfoPopup
      open={openInfoModal}
      ref={dotIndicatorRef}
      onCloseHandler={() => setOpenInfoModal(false)}
      title={title}
      content={content}
    />
  </Fragment>;
};

NewFeatureIndicator.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  property: PropTypes.object,
  id: PropTypes.string,
};

export default NewFeatureIndicator;
